// Analítica propia de la landing. Mismo modelo que Castro y Megatrans (docs/ANALITICA-WEB.md).
// Sin cookies de terceros ni IP guardada: un id anónimo en localStorage para contar únicos.
const URL_EVENTOS = `${process.env.REACT_APP_BACKEND_URL || ''}/api/web-stats/evento`;
const SESION_MS = 30 * 60 * 1000;

const leer = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const guardar = (k, v) => { try { localStorage.setItem(k, v); } catch { /* modo privado */ } };
const nuevoId = () => (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`).slice(0, 36);

function ids() {
  let visitante = leer('clinia_vid');
  if (!visitante) { visitante = nuevoId(); guardar('clinia_vid', visitante); }
  let sesion = leer('clinia_sid');
  const ultimo = Number(leer('clinia_sid_ts') || 0);
  if (!sesion || Date.now() - ultimo > SESION_MS) { sesion = nuevoId(); guardar('clinia_sid', sesion); }
  guardar('clinia_sid_ts', String(Date.now()));
  return { visitante_id: visitante, sesion_id: sesion };
}

export function track(evento, detalle, extra = {}) {
  if (navigator.doNotTrack === '1' || (leer('token') && evento !== 'login')) return; // no medimos a usuarios con sesión
  const p = new URLSearchParams(window.location.search);
  const cuerpo = JSON.stringify({
    evento, detalle: detalle != null ? String(detalle) : null, ...ids(),
    pagina: window.location.pathname, url: window.location.href,
    referrer: document.referrer || null, idioma: navigator.language,
    pantalla: `${window.screen.width}x${window.screen.height}`,
    utm_source: p.get('utm_source'), utm_medium: p.get('utm_medium'), utm_campaign: p.get('utm_campaign'),
    ...extra,
  });
  // text/plain evita el preflight de CORS y permite sendBeacon al cerrar la pestaña
  const blob = new Blob([cuerpo], { type: 'text/plain' });
  if (!(navigator.sendBeacon && navigator.sendBeacon(URL_EVENTOS, blob))) {
    fetch(URL_EVENTOS, { method: 'POST', body: cuerpo, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
  }
}

// Vista, profundidad de scroll, clics en [data-track] y tiempo en página. Devuelve la limpieza.
export function iniciarTracker() {
  const inicio = Date.now();
  const vistos = new Set();
  track('pageview');

  const onScroll = () => {
    const alto = document.documentElement.scrollHeight - window.innerHeight;
    if (alto <= 0) return;
    const pct = (window.scrollY / alto) * 100;
    [25, 50, 75, 100].forEach((m) => { if (pct >= m - 2 && !vistos.has(m)) { vistos.add(m); track('scroll', m); } });
  };
  const onClick = (e) => {
    const el = e.target.closest('[data-track]');
    if (el) track('click', el.getAttribute('data-track'));
  };
  let enviado = false;
  const onSalida = () => {
    if (enviado || document.visibilityState !== 'hidden') return;
    enviado = true;
    track('salida', null, { duracion_ms: Date.now() - inicio });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('click', onClick);
  document.addEventListener('visibilitychange', onSalida);
  return () => {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('click', onClick);
    document.removeEventListener('visibilitychange', onSalida);
  };
}
